import { Page } from 'app/shared/services/app/content/models/page.model';
import { AngularFire, FirebaseListObservable } from 'angularfire2';
import { Observable } from 'rxjs/Observable';
import { CONFIG } from 'app/config/config';

export abstract class FirebaseService {
  pages: Page[] = [];
  firebaseRoot: string;
  firebaseType: string;

  firebaseObservable: Observable<any[]>;
  firebaseList: FirebaseListObservable<any>; // old firebaseEvents, firebasePages, etc

  protected abstract _af: AngularFire;

  initialize(app: string) {
    this.firebaseRoot = 'staging-apps/' + app + '/' + CONFIG.CONTENT_SCHEMA_VERSION;
    this.initFirebaseObservable();
  }

  private initFirebaseObservable() {
    if (!this.firebaseRoot) console.error('Tried to initialize ' + this.firebaseType + ' out of order.');
    this.firebaseList = this._af.database.list(this.firebaseRoot + '/' + this.firebaseType);
    this.firebaseObservable = this.firebaseList.map((events) => this.mapObjJson(events));
  }

  abstract mapObjJson(objs: any, objUrl?: string);

  date() {
    let date = new Date();
    return date.toJSON();
  }

  delete(obj: any) {
    return this._af.database.object(this.firebaseRoot  + '/' + this.firebaseType + obj.firebaseUrl).remove();
  }

  save(obj: any, objUrl?: string) {
    if (objUrl) { // If we are editing the page
      obj.updated_at = this.date();
      return Promise.resolve(this._af.database.object(this.firebaseRoot  + '/' + this.firebaseType + objUrl).update(obj));
    } else { // Otherwise if we are creating it
      obj.created_at = obj.updated_at = this.date();
      return Promise.resolve(this.firebaseList.push(obj));
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/helpers/firebase.service.ts